var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "classnames", "prop-types", "react", "../GuideProgram/GuideProgram", "./ConcertProgramTimeline"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("classnames"), require("prop-types"), require("react"), require("../GuideProgram/GuideProgram"), require("./ConcertProgramTimeline"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.classnames, global.propTypes, global.react, global.GuideProgram, global.ConcertProgramTimeline);
    global.ProgramTimeline = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _classnames, _propTypes, _react, _GuideProgram, _ConcertProgramTimeline) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _GuideProgram = _interopRequireDefault(_GuideProgram);
  _ConcertProgramTimeline = _interopRequireDefault(_ConcertProgramTimeline);

  var TvProgramTimeline = function TvProgramTimeline(_ref) {
    var className = _ref.className,
        concertLabels = _ref.concertLabels,
        programs = _ref.programs,
        showDate = _ref.showDate,
        showHour = _ref.showHour;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('program-timeline', className)
    }, programs.map(function (programProps) {
      return /*#__PURE__*/_react.default.createElement(_GuideProgram.default, (0, _extends2.default)({
        showDate: showDate,
        showHour: showHour,
        key: "".concat(programProps.programId, "-ProgramTimeline")
      }, programProps));
    }));
  };

  var ProgramTimeline = function ProgramTimeline(props) {
    return props.domain === 'tv' ? /*#__PURE__*/_react.default.createElement(TvProgramTimeline, props) : /*#__PURE__*/_react.default.createElement(_ConcertProgramTimeline.default, props);
  };

  ProgramTimeline.propTypes = {
    className: _propTypes.default.string,
    concertLabels: _propTypes.default.shape({
      onAir: _propTypes.default.string,
      livestream: _propTypes.default.string
    }),
    dateLocale: _propTypes.default.shape(),
    domain: _propTypes.default.oneOf(['tv', 'concert']),
    programs: _propTypes.default.arrayOf(_propTypes.default.object),
    showDate: _propTypes.default.bool,
    showHour: _propTypes.default.bool
  };
  ProgramTimeline.defaultProps = {
    className: '',
    concertLabels: {
      onAir: '',
      livestream: ''
    },
    dateLocale: {},
    domain: 'tv',
    programs: [],
    showDate: false,
    showHour: true
  };
  TvProgramTimeline.propTypes = ProgramTimeline.propTypes;
  TvProgramTimeline.defaultProps = ProgramTimeline.defaultProps;
  var _default = ProgramTimeline;
  _exports.default = _default;
});